import { Button, Flex, Select } from "@jsq/ds/core";
import { FormSelect } from "@jsq/ds/forms";
import * as styles from "../styles_vanilla.css";
import type { ReportingQueryOption } from "../hooks/useReportingQueries";

type QuerySelectSectionProps = {
  queryOptions: ReportingQueryOption[];
  queriesLoading: boolean;
  onPreviewFields: () => void;
  showPreviewLink: boolean;
  /**
   * When true, the resolved options are empty because none of the data package's
   * queries support the selected template type. Surfaces an explanatory empty-state
   * placeholder rather than the generic "Select a query" prompt.
   */
  filteredOutByTemplateType?: boolean;
};

const getPlaceholder = (
  queriesLoading: boolean,
  hasOptions: boolean,
  filteredOutByTemplateType: boolean,
) => {
  if (queriesLoading) return "Loading queries...";
  if (!hasOptions && filteredOutByTemplateType) {
    return "No queries available for this template type";
  }
  return "Select a query";
};

export const QuerySelectSection = ({
  queryOptions,
  queriesLoading,
  onPreviewFields,
  showPreviewLink,
  filteredOutByTemplateType = false,
}: QuerySelectSectionProps) => {
  const placeholder = getPlaceholder(
    queriesLoading,
    queryOptions.length > 0,
    filteredOutByTemplateType,
  );

  return (
    <Flex flexDirection="column">
      <FormSelect
        name="query"
        label="Query"
        placeholder={placeholder}
        full
        disabled={queriesLoading || queryOptions.length === 0}
      >
        <Select.Section>
          {queryOptions.map((option) => (
            <Select.Option key={option.id} value={option.id}>
              {option.name}
            </Select.Option>
          ))}
        </Select.Section>
      </FormSelect>
      <Flex justifyContent="flex-start" className={styles.previewFieldsContainer}>
        <Button displayAsLink onClick={onPreviewFields} disabled={!showPreviewLink}>
          Preview fields
        </Button>
      </Flex>
    </Flex>
  );
};
